import {
  IInputRuleBehaviorSpecifiable, instanceOfIInputRuleBehaviorSpecifiable,
  IScriptExecuteBehaviorSpecifiable, instanceOfIScriptExecuteBehaviorSpecifiable,
  ILinkedScriptExecuteBehavior,
} from "../../../../documaker/domain/format/objects";
import { ITextDrawableObject, instanceOfITextDrawableObject } from "./ITextDrawableObject";

export interface IScriptLinkObject extends
ITextDrawableObject,
IInputRuleBehaviorSpecifiable,
IScriptExecuteBehaviorSpecifiable<ILinkedScriptExecuteBehavior> {
}

export function instanceOfIScriptLinkObject(instance: any): instance is IScriptLinkObject {
  return instance
      && instanceOfIInputRuleBehaviorSpecifiable(instance)
      && instanceOfIScriptExecuteBehaviorSpecifiable<ILinkedScriptExecuteBehavior>(instance)
      && instanceOfITextDrawableObject<IScriptLinkObject>(instance, "scriptlink");
}
